import { IFinalEvent } from "types/event"
import Link from "next/link"
import {
    FiFacebook,
    FiInstagram,
    FiLinkedin,
    FiYoutube,
    FiGlobe,
} from "react-icons/fi"
import { FaXTwitter } from "react-icons/fa6"
import { BsSnapchat, BsTiktok } from "react-icons/bs"

interface IProps {
    event: IFinalEvent
    forceColor?: boolean
}

const SocialIcon = ({ link, Icon, forceColor }: any) => {
    return (
        <Link
            href={link}
            className="block h-5 w-5 transition-all hover:scale-110 hover:opacity-100 md:opacity-75"
            rel="noreferrer"
            target={"_blank"}
        >
            <Icon
                className={`h-full w-full text-black ${
                    forceColor ? "dark:text-black" : "dark:text-gray-200"
                }`}
            />
        </Link>
    )
}

const SocialMediaCard = ({ event, forceColor }: IProps) => {
    const socialMediaMapping = [
        { name: "twitter", Icon: FaXTwitter },
        { name: "facebook", Icon: FiFacebook },
        { name: "tiktok", Icon: BsTiktok },
        { name: "instagram", Icon: FiInstagram },
        { name: "linkedin", Icon: FiLinkedin },
        { name: "snapchat", Icon: BsSnapchat },
        { name: "youtube", Icon: FiYoutube },
        { name: "website", Icon: FiGlobe },
    ]

    return socialMediaMapping.map((social) => {
        const link = event?.social_media_links?.[social.name]
        if (link) {
            return (
                <SocialIcon
                    link={link}
                    Icon={social?.Icon}
                    key={social?.name}
                    forceColor={forceColor}
                />
            )
        }
        return null
    })
}

export default SocialMediaCard
